import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['count'];

  replayAll() {
    this.countTargets.forEach((el) => this.#play(el));
  }

  replay(event) {
    const el = event.currentTarget.querySelector('[data-needs-attention-animation-preview-target="count"]');

    if (el) this.#play(el);
  }

  #play(el) {
    const animationClass = el.dataset.animationClass;

    this.#run(el, animationClass);
    el.addEventListener('animationend', () => this.#run(el, animationClass), { once: true });

    const tile = el.closest('[data-tile-animation-class]');
    const tileAnimationClass = tile?.dataset.tileAnimationClass;

    if (tileAnimationClass) {
      this.#run(tile, tileAnimationClass);
      tile.addEventListener('animationend', () => this.#run(tile, tileAnimationClass), { once: true });
    }
  }

  #run(el, animationClass) {
    el.classList.remove(animationClass);
    el.offsetHeight;
    el.classList.add(animationClass);
  }
}
